/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/prefer-inject*/
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  
  constructor(private readonly http: HttpClient) {
  
  }

  protected post<T>(path: string, request: any): Observable<T> {
    return this.http.post<T>(`${this.apiBaseUrl}${path}`, request);
  }

  protected postFile(path: string, request: FormData): Observable<any> {
    const response = this.http.post<FormData>(`${this.apiBaseUrl}${path}`, request, {
      responseType: 'arraybuffer' as 'json',
      observe: 'response',
    });
    return response;
  }
}
